import { FieldSpanStyled } from './FieldSpan.styled';

export const FieldSpanView = FieldSpanStyled;
